// Section 18 and 9: Housing policy. Families first / Workers first / First come / Manual, plus
// allow overcrowding and (stream M3a) split households, as one structured value (ADR-0010 item
// 17). Beds are drawn at the start of the season (phases/shared/housing.ts). The preview names
// beds against people and what happens to those without a bed.
// Default: config.policies.defaults.housing.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { population } from '../../core/queries';
import { sortedValues } from '../../core/sorted';
import { definePolicy, noModifiers } from '../../core/registry';
import type { PreviewLine } from '../../core/types';

export function housing(config: Config) {
  return definePolicy({
    id: 'housing',
    label: 'Housing',
    section: 'S18',
    group: 'housing',
    options: null,
    default: config.policies.defaults.housing,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      let beds = 0;
      for (const b of sortedValues(ctx.state.buildings))
        if (b.condition > 0) beds += ctx.registry.buildings[b.type].beds;
      const people = population(ctx.state);
      const lines: PreviewLine[] = [{ key: 'policy.housing.beds', params: { beds, people } }];
      if (people > beds) {
        lines.push({
          key: option.allowOvercrowding ? 'policy.housing.overcrowd' : 'policy.housing.rough',
          params: { extra: people - beds },
        });
      }
      if (option.splitHouseholds === true) lines.push({ key: 'policy.housing.split', params: {} });
      return lines;
    },
    validate: noProblem,
  });
}
